import React, { useEffect, useState } from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import CityMultipleDistrictForm from './city-multiple-district-form';
import { useLocation } from 'react-router-dom';
import { City } from '@/models/city.model';
import { getCity } from '@/services/city.service';
import { BaseErrorModel, BaseResponseModel } from '@/models/core.model';
import { AxiosError } from 'axios';
import { toastErrorMessage } from '@/utils/toasterMessage';

const Page = () => {
  const cityId = useLocation()?.state?.cityId;
  const [city, setCity] = useState<City|undefined>(undefined);

  useEffect(() => {
    if (cityId) {
      getCity(cityId).then((result: BaseResponseModel<City>) => {
        if (result.success) {
          setCity(result.result);
        }
      }).catch(err => {
        const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
        toastErrorMessage(`Error in fetching city: ${errorModel?.errorMessage}`);
      });
    }
  },[cityId]);

  return (
    <Panel
      header={
        <PageHeader title="Add Multiple Districts">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/cities">Cities</Breadcrumb.Item>
            <Breadcrumb.Item >Districts</Breadcrumb.Item>
            <Breadcrumb.Item active>Add Multiple Districts</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <CityMultipleDistrictForm city={city}/>
    </Panel>
  );
};

export default Page;
